import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-35a2b54f"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "key-value-fa"
};
const _hoisted_2 = ["innerHTML"];
const _hoisted_3 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
    class: "title-dis",
    innerHTML: $props.title || '-'
  }, null, 8, _hoisted_2), _createElementVNode("div", {
    class: _normalizeClass(['value-dis']),
    innerHTML: $props.value || '-'
  }, null, 8, _hoisted_3)]);
}